(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lv-welcome-popup"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-welcome-popup]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('dialog');
      if (!dialog) return;

      const key = `lunaveil-welcome-popup-${root.id}`;
      const dismissDays = Number(root.dataset.dismissDays || 7);
      const delay = Number(root.dataset.delay || 8000);
      const isDesignMode = root.dataset.designMode === 'true';
      const hasSucceeded = Boolean(root.querySelector('[data-welcome-success]'));
      const hasError = Boolean(root.querySelector('[data-welcome-errors]'));
      const mobileDisabled = root.dataset.mobileEnabled !== 'true' && window.matchMedia('(max-width: 749px)').matches;
      let timer;
      let opened = false;

      const readState = () => {
        try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return {}; }
      };

      const writeState = (state) => {
        try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
      };

      const isSuppressed = () => {
        const state = readState();
        if (state.joined) return true;
        if (!state.dismissedAt) return false;
        return Date.now() - Number(state.dismissedAt) < dismissDays * 86400000;
      };

      const open = () => {
        if (opened || dialog.open || mobileDisabled) return;
        opened = true;
        dialog.showModal();
        window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        requestAnimationFrame(() => {
          const target = dialog.querySelector('[data-welcome-success], input, button');
          target?.focus({ preventScroll: true });
        });
      };

      const dismiss = () => {
        if (!hasSucceeded && !isDesignMode) writeState({ dismissedAt: Date.now() });
        dialog.close();
      };

      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.35) open();
      };

      root.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', dismiss));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && dialog.open) dismiss(); });

      root.querySelector('[data-welcome-copy]')?.addEventListener('click', async (event) => {
        const code = root.querySelector('[data-welcome-code]')?.textContent.trim();
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          event.currentTarget.textContent = 'Copied';
        } catch (_) {
          root.querySelector('[data-welcome-code]')?.focus();
        }
      });

      if (hasSucceeded) {
        writeState({ joined: true });
        open();
      } else if (hasError || isDesignMode) {
        open();
      } else if (!isSuppressed() && !mobileDisabled && !location.pathname.match(/^\/(cart|checkout|account)(\/|$)/)) {
        timer = window.setTimeout(open, delay);
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === root.id.replace('LvWelcomePopup-', '')) open();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
